module.exports = __webpack_public_path__ + "static/media/WorkoutPlan.197905f1.png";